import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteExameneMedico,
  getExamenesMedicos,
  patchExameneMedico,
  postExameneMedico,
} from 'api/catalogos/examenMedico';

// eslint-disable-next-line react/prop-types
const ExamenMedico = ({ permission }) => (
  <PlainCRUD
    title="Examen médico"
    permission={permission}
    get={getExamenesMedicos}
    post={postExameneMedico}
    patch={patchExameneMedico}
    delete={deleteExameneMedico}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
      {
        name: 'es_proveedor_externo',
        label: 'Proveedor externo',
        type: 'select',
      },
    ]}
  />
);
export default ExamenMedico;
